export function isTabWithForm(tab: DynamicTabWithTable<any> | DynamicTabWithForm<any>): tab is DynamicTabWithForm<any> {
  return (tab as DynamicTabWithForm<any>).form !== undefined;
}